
import { Component, ChangeDetectionStrategy, input, output, signal, effect } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-platform-legal-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './platform-legal-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformLegalModalComponent {
  isOpen = input.required<boolean>();
  initialTab = input<'tos' | 'privacy'>('tos');
  
  closeModal = output<void>();

  activeTab = signal<'tos' | 'privacy'>('tos');

  constructor() {
    effect(() => {
      if (this.isOpen()) {
        this.activeTab.set(this.initialTab());
      }
    });
  }

  onClose() {
    this.closeModal.emit();
  }

  setTab(tab: 'tos' | 'privacy') {
    this.activeTab.set(tab);
  }

  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
